<!-- 问卷 -->
<template>
  <div class="sponsor">
    <v-head></v-head>
    <div class="container" style="min-width:1200px;">
      <!-- banner -->
      <div class="sponsor-banner">
        <el-carousel trigger="click" :interval="5000" arrow="never" height="100%">
          <el-carousel-item v-for="(item,index) in bannerList" :key="index">
            <div class="banner-img" :style="'background-image:url(' + item.image_url + ')'"></div>
            <div class="help-banner-zz"></div>
            <div class="sponsor-banner-con">
              <div class="sponsor-banner-title">{{ item.title }}</div>
              <div class="sponsor-banner-line">—</div>
              <div class="sponsor-banner-message">{{ item.description }}</div>
              <div class="sponsor-banner-more">
                <a href="javascript:void(0);">
                  <el-button size="small">
                    {{ item.button_name }}
                    <i class="el-icon-arrow-right"></i>
                  </el-button>
                </a>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <!-- <div class="sponsor-banner-img">
          <div class="sponsor-banner-bg" :style="'background-image:url(' + img + ')'"></div>
          <div class="sponsor-banner-con">
            <div class="sponsor-banner-title">校园问卷</div>
            <div class="sponsor-banner-line">—</div>
            <div
              class="sponsor-banner-message"
            >每天全国有近万场校园活动在开展，存在巨大的活动活动需求，我们平台为企业、学生社团搭建了信息沟通桥梁，企业可以第一时间了解到各个学校社团计划开展的活动信息，选取适合企业品牌建设需要的活动进行赞助，帮助企业在校园进行品牌推广</div>
            <div class="sponsor-banner-more">
              <el-button size="small" @click="toDetails()">
                了解更多
                <i class="el-icon-arrow-right"></i>
              </el-button>
            </div>
          </div>
        </div>-->
      </div>
      <!-- 活动展示 -->
      <div class="sponsor-activity">
        <!-- 活动切换nav -->
        <el-tabs class="sponsor-activity-nav" v-model="activityed" type="border-card">
          <el-tab-pane
            v-for="(item,index) of activityList"
            :key="index"
            :label="item.label"
            :name="item.label"
          >
            <div class="sponsor-activity-con">
              <div class="activity-con-title">{{ item.label }}</div>
              <div class="activity-con-message">{{ item.message }}</div>
              <div class="activity-con-cut">
                <div
                  class="activity-cut-prev"
                  :class="activityed === activityList[0].label?'activity-disabled':''"
                  @click="prev()"
                >
                  <i class="el-icon-arrow-left"></i>
                </div>
                <div
                  class="activity-cut-next"
                  :class="activityed === activityList[activityList.length-1].label?'activity-disabled':''"
                  @click="next()"
                >
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 问卷调查案例 -->
      <div class="sponsor-case" id="parttime-case">
        <div class="case-title">
          <span class="case-title-t">数据报告案例</span>
          <span class="case-title-b">深度挖掘在校大学生的行为数据、兴趣喜好与消费需求</span>
        </div>
        <div class="case-main">
          <!-- 列表展示 -->
          <div class="case-list">
            <!-- A4 -->
            <div
              class="case-list-item"
              @click="toops()"
              :style="'backgroundImage:url(' + img1 + ')'"
            ></div>
            <div
              class="case-list-item"
              @click="toops()"
              :style="'backgroundImage:url(' + img2 + ')'"
            ></div>
            <div
              class="case-list-item"
              @click="toops()"
              :style="'backgroundImage:url(' + img3 + ')'"
            ></div>
            <div
              class="case-list-item"
              @click="toops()"
              :style="'backgroundImage:url(' + img4 + ')'"
            ></div>
            <!-- A4 -->
            <div
              class="case-list-item"
              @click="toops()"
              :style="'backgroundImage:url(' + img5 + ')'"
            ></div>
            <div
              class="case-list-item"
              @click="toops()"
              :style="'backgroundImage:url(' + img6 + ')'"
            ></div>
            <div
              class="case-list-item"
              @click="toops()"
              :style="'backgroundImage:url(' + img7 + ')'"
            ></div>
            <div
              class="case-list-item"
              @click="toops()"
              :style="'backgroundImage:url(' + img8 + ')'"
            ></div>
            <!-- A4 -->
            <div
              class="case-list-item"
              @click="toops()"
              :style="'backgroundImage:url(' + img9 + ')'"
            ></div>
            <div
              class="case-list-item"
              @click="toops()"
              :style="'backgroundImage:url(' + img10 + ')'"
            ></div>
            <div
              class="case-list-item"
              @click="toops()"
              :style="'backgroundImage:url(' + img11 + ')'"
            ></div>
            <div
              class="case-list-item"
              @click="toops()"
              :style="'backgroundImage:url(' + img12 + ')'"
            ></div>
            <div
              class="case-list-item"
              @click="toops()"
              :style="'backgroundImage:url(' + img13 + ')'"
            ></div>
            <div
              class="case-list-item"
              @click="toops()"
              :style="'backgroundImage:url(' + img14 + ')'"
            ></div>
            <div
              class="case-list-item"
              @click="toops()"
              :style="'backgroundImage:url(' + img15 + ')'"
            ></div>
          </div>
        </div>
      </div>
      <!-- 关联企业 -->
      <!-- <v-relation style="background-color:#ffffff;"></v-relation> -->
    </div>
    <!-- footer -->
    <v-footer></v-footer>
    <transition name="fade">
      <div class="modelBox" v-if="show">
        <div class="model_text">您暂未获得查阅权限</div>
      </div>
    </transition>
  </div>
</template>
<script>
import vHead from '@/components/header/header.vue'
import vFooter from '@/components/footer/footer.vue'
import vRelation from '@/components/relation/relation.vue'
import img1 from '@/assets/img/fm1.jpg'
import img2 from '@/assets/img/fm2.jpg'
import img3 from '@/assets/img/fm3.jpg'
import img4 from '@/assets/img/fm4.jpg'
import img5 from '@/assets/img/fm5.jpg'
import img6 from '@/assets/img/fm6.jpg'
import img7 from '@/assets/img/fm7.jpg'
import img8 from '@/assets/img/fm8.jpg'
import img9 from '@/assets/img/fm9.jpg'
import img10 from '@/assets/img/fm10.jpg'
import img11 from '@/assets/img/fm11.jpg'
import img12 from '@/assets/img/fm12.jpg'
import img13 from '@/assets/img/fm13.jpg'
import img14 from '@/assets/img/fm14.jpg'
import img15 from '@/assets/img/fm15.jpg'
import {
  Carousel,
  CarouselItem,
  Button,
  Tabs,
  TabPane,
  Input
} from 'element-ui'
// import Swiper from 'swiper'
export default {
  data () {
    return {
      show: false,
      img1: img1,
      img2: img2,
      img3: img3,
      img4: img4,
      img5: img5,
      img6: img6,
      img7: img7,
      img8: img8,
      img9: img9,
      img10: img10,
      img11: img11,
      img12: img12,
      img13: img13,
      img14: img14,
      img15: img15,
      searchModel: '',
      activityed: '校园问卷',
      activityList: [{
        label: '校园问卷',
        message: '通过到梦空间优势，达到全域非定时采集功用，配套活动及相应奖励，在保证样本质量的同时，低成本高效采集学生需求数据。'
      }, {
        label: '品牌调研',
        message: '系统数据、行政指令、社团任务、工具采集等方式，在提升高校围墙内品牌知名度的同时，为品牌深入了解大学生消费需求提供解决方案。'
      }, {
        label: '行为洞察',
        message: '通过独有的数据分析模型，从第三方数据和自有数据等大数据提炼出有用的数据和洞察，以此驱动精准而有影响力的市场营销，探索不同业务中的关键行为，洞察指标背后的增长点。'
      }, {
        label: '用户精准筛选',
        message: '采集用户行为数据，抓取用户每一个行为背后的多维属性，丰富用户标签体系。您可以快速筛选符合活动设想的精准人群，让精细化成为习惯。'
      }, {
        label: '受众精细化触达',
        message: '大学生数据研究院为您打通了短信、微信、弹窗、App 推送等多种用户触达通道，强大的 Webhook 帮助对接各类内部系统，实现与所需求用户真正互动。'
      }],
      bannerList: [{
        button_name: '了解更多',
        description: '大学生第二课堂在校数据，除学籍、户籍、身份信息、成绩等基础信息外，有大量需求数据、导向数据、行为数据、标签化数据可供研究与深度挖掘，为政府、高校、行业提供研究成果，促进改革实施、优化策略、供给内容。',
        id: 0,
        image_url: 'https://sponsorentpic.nauac.com/20200506/36bc886c6dca4d46b493b093b96095a6.jpg',
        title: '大学生数据研究院',
        url: 'https://sponsorentpic.nauac.com/20200506/36bc886c6dca4d46b493b093b96095a6.jpg'
      }],
      caseList: []
    }
  },
  components: {
    'el-carousel': Carousel,
    'el-carousel-item': CarouselItem,
    'v-head': vHead,
    'v-footer': vFooter,
    'el-button': Button,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'v-relation': vRelation,
    'el-input': Input
  },
  created () {
    // 移动端适配最小高度为浏览器高度
    this.$nextTick(() => {
      let containerDom = document.getElementsByClassName('container')[0]
      if (containerDom) {
        containerDom.style.minHeight = (document.documentElement.clientHeight - 100) + 'px'
      }
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // this.$http({
      //   method: 'post',
      //   url: '/sponsor/case/list'
      // }).then(res => {
      //   if (res.code === 100) {
      //     this.caseList = res.result.list
      //   }
      // }).catch(error => {
      //   console.log(error)
      //   return false
      // })
    },
    toops () {
      this.show = true
      window.setTimeout(() => {
        this.show = false
      }, 1200)
    },
    prev () {
      for (let i = 0; i < this.activityList.length; i++) {
        if (this.activityList[i].label === this.activityed) {
          if (i === 0) {
            return
          } else {
            this.activityed = this.activityList[i - 1].label
            return
          }
        }
      }
    },
    next (e) {
      for (let i = 0; i < this.activityList.length; i++) {
        if (this.activityList[i].label === this.activityed) {
          if (i === (this.activityList.length - 1)) {
            return
          } else {
            this.activityed = this.activityList[i + 1].label
            return
          }
        }
      }
    },
    toDetails () {
      document.getElementById('parttime-case').scrollIntoView({ behavior: 'instant', block: 'center', inline: 'center' })
    }
  }
}
</script>
<style lang="css" scope>
.sponsor {
  width: 100%;
}
@media screen and (max-width: 1201px) {
  .case-main {
    width: 1100px !important;
    max-width: 1100px !important;
  }
}
</style>
<style src='./exam.scss' lang="scss" scoped></style>
<style src='./exam_active.scss' lang="scss" ></style>



// WEBPACK FOOTER //
// src/views/exam/exam.vue